import FlagsSelect from './FlagsSelect.view';

export default FlagsSelect;
